import { render, staticRenderFns } from "./workspace-member-card.vue?vue&type=template&id=68c1fa00&scoped=true&"
import script from "./workspace-member-card.vue?vue&type=script&lang=js&"
export * from "./workspace-member-card.vue?vue&type=script&lang=js&"
import style0 from "./workspace-member-card.vue?vue&type=style&index=0&id=68c1fa00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c1fa00",
  null
  
)

export default component.exports